import type { InputProps } from '@farmersdog/corgi';
import { FormControl, Input } from '@farmersdog/corgi';

import type { ChangeEvent } from 'react';

export interface ZipInputProps extends Omit<InputProps, 'ref'> {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  validationMessage: string;
}

export const ZipInput = ({
  className,
  value,
  onChange,
  validationMessage,
  ...props
}: ZipInputProps) => (
  <FormControl
    aria-live="polite"
    className={className}
    invalid={Boolean(validationMessage)}
    message={validationMessage}
  >
    <Input
      {...props}
      autoComplete="postal-code"
      inputMode="numeric"
      label="Zip Code"
      name="zip"
      type="text"
      value={value}
      onChange={onChange}
    />
  </FormControl>
);
